import { TypedDocumentNode, gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getInternationalCompetitionsRule_so5Rules } from './__generated__/getInternationalCompetitionsRule.graphql';
import { getCompetitionsRuleDataFromCompetitions } from './getCompetitionsRule';

export const getInternationalCompetitionsRule = withFragments(
  (
    rules: getInternationalCompetitionsRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.internationalCompetitions;
    if (!rule?.length) {
      return null;
    }

    return {
      id: 'internationalCompetitions',
      ...getCompetitionsRuleDataFromCompetitions(rule),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getInternationalCompetitionsRule_so5Rules on So5Rules {
        id
        internationalCompetitions {
          slug
          ...getCompetitionsRuleDataFromCompetitions_competition
        }
      }
      ${getCompetitionsRuleDataFromCompetitions.fragments.competition}
    ` as TypedDocumentNode<getInternationalCompetitionsRule_so5Rules>,
  }
);
